import React, { useEffect, useState, useRef } from 'react';
import NotificationCard from './notificationCard';
import './notifications.scss';
import PropTypes from 'prop-types';
import { getNotificationsDetails, UpdateNotification } from '../../Api/request/commonService';
import UseAxios from '../../Api/http/http';
import { useAuth } from '../../Contexts/AuthContext';
import { STATUS_CODES } from '../../Api/resources/statusCodes';
import Loader from '../../Components/Loader';
import ApprovalNotification from './ApprovalNotification';

const Notifications = ({
  onSelect,
  title = 'Notifications',
  titleStyle,
  onClose,
}) => {
  const { userProfile } = useAuth();
  const userPortal = userProfile?.userPortalId;

  const [notificationsData, setNotificationsData] = useState({});
  const [loading, setLoading] = useState(true);
  const [hasApprovalPending, setHasApprovalPending] = useState(false);
  const containerRef = useRef(null);

  const fetchNotifications = async () => {
    setLoading(true);
    try {
      const reqConfig = getNotificationsDetails(userPortal);
      const response = await UseAxios(reqConfig);
      setNotificationsData(response.data?.notifications || {});
    } catch (error) {
      setNotificationsData({});
    } finally {
      setLoading(false);
    }
  };

  const handleMarksAsRead = async (notificationId = 'All') => {
    try {
      const response = await UseAxios(
        UpdateNotification({ notificationId, readStatus: true, userPortalId: userPortal }),
      );
      if (response.data.status === STATUS_CODES.SUCCESS) {
        fetchNotifications();
      }
    } catch (error) {
      console.error('Error updating notification:', error);
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        if (onClose) onClose();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  useEffect(() => {
    if (userPortal) {
      fetchNotifications();
    }
  }, [userPortal]);
  return (
    <div className="notifications-container" ref={containerRef}>
      <div className="notifications-header">
        <div
          className="notifications-title"
          style={titleStyle}
        >
          {title}
        </div>
        {Object.keys(notificationsData).length > 0 && (
          <span
            className="notifications-mark-read"
            onClick={event => {
              event.preventDefault();
              handleMarksAsRead();
            }}
            style={{ cursor: 'pointer' }}
          >
            Mark as Read
          </span>
        )}
      </div>
      <div className="notifications-scrollable-list">
        <ApprovalNotification onClose={onClose} onStatsFetch={total => setHasApprovalPending(total > 0)} />
        {loading && !hasApprovalPending ? (
          <Loader />
        ) : (Object.keys(notificationsData).length === 0 && !hasApprovalPending) ? (
          <div className="notifications-empty">No notifications</div>
        ) : Object.keys(notificationsData).length === 0 ? null : (
          Object.entries(notificationsData).map(([date, notifs]) => (
            <div key={date}>
              <div className="notifications-date-row">
                <div className="notifications-date">
                  {date}
                </div>
                <div className="notifications-divider" />
              </div>
              {notifs.map((notif, idx) => (
                <div key={notif.id || idx} className="notifications-item">
                  <div
                    onClick={async () => {
                      await handleMarksAsRead(notif.id);
                      if (onSelect) onSelect(notif);
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    <NotificationCard {...notif} />
                  </div>
                </div>
              ))}
            </div>
          ))
        )}
      </div>
      {Object.keys(notificationsData).length > 0 && (
        <div className="notifications-footer-row">
          <div className="notifications-footer-line" />
          <div className="notifications-footer">
            Notifications received within the past 30 days
          </div>
          <div className="notifications-footer-line" />
        </div>
      )}
    </div>
  );
};
Notifications.propTypes = {
  onSelect: PropTypes.func,
  selected: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  title: PropTypes.string,
  titleStyle: PropTypes.object,
  onClose: PropTypes.func,
  userPortalId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Notifications;
